import { FileStorageTypes } from '@app/enums/file-storage-types.enum';

export class ThirdPartyEvaluationFormItemFile {
    id: number = 0;
    fileName: string = '';
    fileSize: number = 0;
    type: string = '';
    file: string;
    createUser: string = null;
    fileStorageType: FileStorageTypes = FileStorageTypes.FileImported; 

  constructor(File, createUser?: string) {
    File = File || {};
    this.id = File.id || 0;
    this.fileName = File.fileName || '';
    this.fileSize = File.fileSize || 0;
    this.file = File.file;
    this.type = File.type || '';
    this.createUser = createUser;
    this.fileStorageType = FileStorageTypes.FileImported
  }
}